<!--
 * @Author: lan.h
 * @Date: 2022-02-21 17:50:06
 * @LastEditors:  
 * @LastEditTime: 2022-05-17 15:19:30
 * @Description: 报告图表
-->
<template>
  <div class="report" v-if="report.length > 0">
    <div class="mode-title">
      <span class="title-p">报告图表</span>
      <div class="comp-src-name">报告图表数据由 <img @click="haddleApplyTry2(32)" :src="$store.state.static_img_url+'pic/logo.png'" alt="动脉橙"> 提供支持</div>
    </div>
    <ul class="report-content">
      <li v-for="item, index in report" :key="index" @click="handReport(item)">
        <div class="img">
          <img class="logo" v-if="item.reportType == 0" :src="item.filePath | logo_show('/report_type_img')">
          <img class="logo" v-else :src="item.filePath | logo_show('/report_image')">
        </div>
        <div class="desc">{{item.fileName}}</div>
      </li>
    </ul>
    <div class="flash-more" @click="more">
      <a>查看更多</a>
    </div>
    <ReportModal :isReportModal="is_reportModal" :detail="detail" :relation="relation" @closeModal="closeModal"></ReportModal>
  </div>
</template>

<script>
import ReportModal from './ReportModal'
import { getReportChartList } from '../../service'
export default {
  inject: ["login", 'haddleApplyTry2'],
  props: {
    //数量
    size: {
      default: 4
    },
    //埋点
    pageType: {
      default: ''    //1首页 2文章详情
    }
  },
  data() {
    return {
      report: [],
      detail: {},
      relation: [],
      is_reportModal: false,
      loading: false,
    }
  },
  computed: {
    user_key() {
      return this.$store.state.user_key
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.loading = true
      let res = await getReportChartList( {
        app_layer_tag: [],
        name: '',
        page: 1,
        size: this.size
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.code == 0) {
        this.$set(this.$data, 'report', res.data.records)
        this.loading = false
      } else {
        this.$Message.error(res.msg)
      }
    },
    async handReport(item) {
      if(this.pageType == '1'){
        _czc.push(['_trackEvent', '首页(新)', '右侧图表报告(报告标题/图片)', '点击量'])
      }
      else if(this.pageType == '2'){
        _czc.push(['_trackEvent', '文章详细页(新)', '右侧(图表报告)', '点击量'])
      }
      if (!this.user_key) {
        this.login()
        return
      }
      this.detail = item
      let res = await getReportChartList( {
        file_id: this.detail.id,
        app_layer_tag: this.detail.reportTag,
        name: '',
        page: 1,
        size: 3
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.code == 0) {
        this.$set(this.$data, 'relation', res.data.records)
        this.is_reportModal = true
      } else {
        this.$Message.error(res.msg)
      }
    },
    closeModal(val) {
      this.is_reportModal = false
    },
    more() {
      const href = this.$store.state.index_path + '/chartSet'
      window.open(href, '_blank')
      if(this.pageType == '1'){
        _czc.push(['_trackEvent', '首页(新)', '右侧图表报告(查看更多)', '点击量'])
      }
      else if(this.pageType == '2'){
        _czc.push(['_trackEvent', '文章详细页(新)', '右侧(图表报告更多)', '点击量'])
      }
    }
  },
  components: {
    ReportModal
  }
}
</script>

<style lang="stylus" scoped>
.report
  &-content
    margin-top 20px
    background #F8F9FA
    padding 0 10px 10px
    display flex 
    flex-flow wrap
    justify-content space-between
    li 
      width calc((100% - 10px) / 2)
      margin-top 10px
      cursor pointer
      .img 
        width 100%
        height 100px
        overflow hidden
        background #fff
        display flex 
        justify-content center 
        align-items center
        img
          max-width 100%
          max-height 100%
          &:hover
            transform scale(1.1)
            transition all 0.6s ease 0s
      .desc
        margin-top 8px
        font-size 12px
        font-weight 500
        color #333333
        line-height 18px
        word-break break-all
        &:hover 
          transition all 0.5s
          color #FA5A00
  .flash-more
    margin-top 20px

</style>